/* Shop All interactions. No-op unless .ld-shopall-header is present.
   Event delegation throughout -> survives InstantClick body swaps. */
(function () {
  'use strict';

  var root = document.documentElement;

  // window.LDT = translations bridge rendered in collection-shopall-toolbar; read lazily for InstantClick swaps.
  function T() { return window.LDT || {}; }

  function isShopAll() { return !!document.querySelector('.ld-shopall-header'); }
  function markShopAll() { if (isShopAll()) root.classList.add('ld-shopall'); else root.classList.remove('ld-shopall'); }
  function isCollection() { return !!document.querySelector('.ld-stickybar'); }
  function markCollection() { if (isCollection()) root.classList.add('ld-collection'); else root.classList.remove('ld-collection'); }

  function updateStickyOffset() {
    if (!root.classList.contains('ld-collection')) return;
    var off = 0;
    var els = document.querySelectorAll('#header, .main-nav__wrapper');
    for (var i = 0; i < els.length; i++) {
      var cs = getComputedStyle(els[i]);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = els[i].getBoundingClientRect();
      if (r.top <= 1 && r.bottom > off) off = Math.round(r.bottom);
    }
    root.style.setProperty('--ld-sticky-top', off + 'px');
  }
  var stickyQueued = false, stickyTrail = null, stickyTrail2 = null;
  function queueStickyOffset() {
    if (!stickyQueued) {
      stickyQueued = true;
      requestAnimationFrame(function () { stickyQueued = false; updateStickyOffset(); });
    }
    clearTimeout(stickyTrail);
    clearTimeout(stickyTrail2);
    stickyTrail = setTimeout(updateStickyOffset, 200);
    stickyTrail2 = setTimeout(updateStickyOffset, 800);
  }
  window.addEventListener('scroll', queueStickyOffset, { passive: true });
  window.addEventListener('resize', queueStickyOffset);

  function money(c) { c = Math.round(+c || 0); return '$' + (c / 100).toFixed(2); }

  function getScrim() {
    var s = document.querySelector('.ld-scrim');
    if (!s) { s = document.createElement('div'); s.className = 'ld-scrim'; s.setAttribute('data-ld-close', ''); document.body.appendChild(s); }
    return s;
  }
  function openScrim() { getScrim().classList.add('is-open'); }
  function closeScrim() { var s = document.querySelector('.ld-scrim'); if (s) s.classList.remove('is-open'); }

  var sheetEl = null, movedSheet = null, sheetReturn = null;
  function sheetHost() { return document.querySelector('.section.collection-page, .section.search-page') || document.body; }
  function getSheet() {
    if (sheetEl) { if (!sheetEl.isConnected) sheetHost().appendChild(sheetEl); return sheetEl; }
    sheetEl = document.createElement('div');
    sheetEl.className = 'ld-sheet';
    sheetEl.innerHTML =
      '<div class="ld-sheet__scrim" data-ld-close></div>' +
      '<div class="ld-sheet__panel" role="dialog" aria-modal="true" tabindex="-1" aria-label="' + (T().chooseAria || 'Choose options') + '">' +
      '<button class="ld-sheet__close" type="button" data-ld-close aria-label="' + (T().closeAria || 'Close') + '">&times;</button>' +
      '<div class="ld-sheet__body"></div>' +
      '</div>';
    sheetHost().appendChild(sheetEl);
    return sheetEl;
  }

  function activeMode(sheet) { var r = sheet.querySelector('input[name="ld-mode"]:checked'); return r ? r.value : 'onetime'; }

  function perServing(el, cents, servings, label) {
    if (!el) return;
    if (servings > 0 && cents > 0) {
      el.innerHTML = '<strong>' + money(cents / servings) + '</strong> ';
      el.appendChild(document.createTextNode(label));
      el.hidden = false;
    } else { el.hidden = true; el.textContent = ''; }
  }

  function recompute(sheet) {
    if (!sheet) return;
    var onetime = +sheet.dataset.onetime || 0;
    var sub = +sheet.dataset.sub || 0;
    var qtyEl = sheet.querySelector('[data-ld-qty-val]');
    var qty = qtyEl ? (+qtyEl.textContent || 1) : 1;
    var useSub = activeMode(sheet) === 'subscribe' && sub > 0;
    var unit = useSub ? sub : onetime;

    var planInput = sheet.querySelector('[data-ld-plan-input]');
    var cadence = sheet.querySelector('[data-ld-cadence]');
    if (planInput) planInput.value = (useSub && cadence) ? cadence.value : '';

    var qtyInput = sheet.querySelector('[data-ld-qty-input]');
    if (qtyInput) qtyInput.value = qty;

    var total = sheet.querySelector('[data-ld-cs-total]');
    if (total) total.textContent = money(unit * qty);

    var servings = +sheet.dataset.servings || 0;
    var psLabel = sheet.dataset.perservLabel || '';
    perServing(sheet.querySelector('[data-ld-perserv-sub]'), sub, servings, psLabel);
    perServing(sheet.querySelector('[data-ld-perserv-one]'), onetime, servings, psLabel);

    var saveEl = sheet.querySelector('[data-ld-save-badge]');
    if (saveEl) {
      var saveCents = (sub > 0 && onetime > sub) ? onetime - sub : 0;
      if (saveCents > 0) {
        saveEl.textContent = (T().saveBadge || 'Save {amount}').replace('{amount}', money(saveCents));
        saveEl.hidden = false;
      } else { saveEl.hidden = true; }
    }

    var addBtn = sheet.querySelector('[data-ld-cs-add]');
    var ctaLabel = sheet.querySelector('[data-ld-cs-label]');
    if (addBtn && ctaLabel) ctaLabel.textContent = useSub ? addBtn.getAttribute('data-label-sub') : addBtn.getAttribute('data-label-one');

    var modeName = activeMode(sheet);
    var labels = sheet.querySelectorAll('[data-ld-mode-label]');
    for (var i = 0; i < labels.length; i++) {
      labels[i].classList.toggle('is-active', labels[i].getAttribute('data-ld-mode-label') === modeName);
    }
  }

  function copyRating(sheet) {
    var ratingSlot = sheet.querySelector('[data-ld-rating]');
    if (!ratingSlot) return;
    // Stamped populates badges on its own pass; copy the card's rendered stars rather than re-initialising
    var card = sheet.closest('.landish-shopall-card');
    var srcBadge = card && card.querySelector('.stamped-product-reviews-badge');
    ratingSlot.innerHTML = srcBadge ? srcBadge.innerHTML : '';
    // the site-wide forcer in theme.liquid only scans .stamped-product-reviews-badge, so this copy needs the same rule
    var rBadge = ratingSlot.querySelector('.stamped-badge');
    var rCap = ratingSlot.querySelector('.stamped-badge-caption');
    var rVal = rBadge && rBadge.getAttribute('data-rating');
    if (rCap && rVal) rCap.textContent = rVal;
  }

  function mountSheet(sheet) {
    sheetReturn = null;
    if (sheet.parentNode) {
      sheetReturn = document.createComment('ld-sheet-home');
      sheet.parentNode.insertBefore(sheetReturn, sheet);
    }
    movedSheet = sheet;
    sheet.hidden = false;
    getSheet().querySelector('.ld-sheet__body').appendChild(sheet);
    recompute(sheet);
    warmBlends(sheet);
  }
  function warmBlends(sheet) {
    var tiles = sheet.querySelectorAll('[data-ld-blend]');
    for (var i = 0; i < tiles.length; i++) {
      var img = document.querySelector('.ld-choose-sheet[data-product="' + tiles[i].getAttribute('data-ld-blend') + '"] .ld-cs__media img');
      if (img) img.loading = 'eager';
    }
  }
  function unmountSheet() {
    if (!movedSheet) return;
    movedSheet.hidden = true;
    if (sheetReturn && sheetReturn.parentNode) sheetReturn.parentNode.replaceChild(movedSheet, sheetReturn);
    else if (movedSheet.parentNode) movedSheet.parentNode.removeChild(movedSheet);
    movedSheet = null; sheetReturn = null;
  }

  function openChoose(id) {
    var sheet = document.getElementById('ld-sheet-' + id);
    if (!sheet) return;
    copyRating(sheet);
    closeAll();
    mountSheet(sheet);
    var host = getSheet();
    host.classList.add('is-open');
    root.classList.add('ld-sheet-open');
    focusDialog(host.querySelector('.ld-sheet__panel'));
  }
  function closeSheet() {
    if (sheetEl) sheetEl.classList.remove('is-open');
    unmountSheet();
    root.classList.remove('ld-sheet-open');
  }

  function carryState(from, to) {
    var mode = from.querySelector('input[name="ld-mode"]:checked');
    var toMode = mode && to.querySelector('input[name="ld-mode"][value="' + mode.value + '"]');
    if (toMode) toMode.checked = true;
    var cad = from.querySelector('[data-ld-cadence]');
    var toCad = to.querySelector('[data-ld-cadence]');
    if (cad && toCad && cad.selectedIndex >= 0) {
      var plan = cad.options[cad.selectedIndex].text;
      for (var i = 0; i < toCad.options.length; i++) {
        if (toCad.options[i].text === plan) { toCad.selectedIndex = i; break; }
      }
    }
    var qty = from.querySelector('[data-ld-qty-val]');
    var toQty = to.querySelector('[data-ld-qty-val]');
    if (qty && toQty) toQty.textContent = qty.textContent;
  }

  function switchBlend(btn) {
    var current = btn.closest('.ld-choose-sheet');
    if (!current || current !== movedSheet || btn.classList.contains('is-active')) return;
    var pid = btn.getAttribute('data-ld-blend');
    var next = document.querySelector('.ld-choose-sheet[data-product="' + pid + '"]');
    if (!next) { window.location.href = btn.getAttribute('data-url'); return; }
    carryState(current, next);
    copyRating(next);
    unmountSheet();
    mountSheet(next);
    var tile = next.querySelector('[data-ld-blend="' + pid + '"]');
    if (tile) tile.focus();
  }

  var lastOpener = null;
  function activeDialog() {
    if (root.classList.contains('ld-filter-open')) return document.querySelector('.ld-filterdrawer');
    if (root.classList.contains('ld-sort-open')) return document.querySelector('.ld-sortdrawer');
    if (root.classList.contains('ld-sheet-open')) return sheetEl && sheetEl.querySelector('.ld-sheet__panel');
    return null;
  }
  function focusDialog(el) {
    lastOpener = document.activeElement;
    if (el && el.focus) el.focus();
  }
  function setExpanded(sel, on) {
    var btns = document.querySelectorAll(sel);
    for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var dialog = activeDialog();
    if (!dialog) return;
    var nodes = dialog.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    var focusables = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].offsetParent !== null || nodes[i] === document.activeElement) focusables.push(nodes[i]);
    }
    if (!focusables.length) { e.preventDefault(); dialog.focus(); return; }
    var first = focusables[0], last = focusables[focusables.length - 1], current = document.activeElement;
    if (!dialog.contains(current)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && (current === first || current === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && current === last) { e.preventDefault(); first.focus(); }
  });

  function openFilter() {
    root.classList.add('ld-filter-open');
    openScrim();
    setExpanded('[data-ld-open-filter]', true);
    focusDialog(document.querySelector('.ld-filterdrawer'));
  }
  function openSort() {
    root.classList.add('ld-sort-open');
    openScrim();
    setExpanded('[data-ld-open-sort]', true);
    focusDialog(document.querySelector('.ld-sortdrawer'));
  }

  var quickMode = 'all';

  var QUICK_DEFS = {
    all:  { title: 'Best sellers' },
    new:  { label: 'New', title: 'New picks', collections: ['new'] },
    best: { label: 'Bestsellers', title: 'Bestsellers picks', collections: ['best-seller'] },
    sale: { label: 'On sale', title: 'On sale picks', collections: ['on-sale'], onSale: true },
    bundles: { label: 'Bundles', title: 'Bundle picks', collections: ['bundles'] },
    beauty:    { label: 'Beauty', tags: ['Beauty'] },
    strength:  { label: 'Strength', tags: ['Strength'] },
    hydration: { label: 'Hydration', tags: ['Hydration'] },
    wellness:  { label: 'Daily Wellness', tags: ['Daily Wellness'] },
    collagen:  { label: 'Collagen', tags: ['Collagen'] },
    creatine:  { label: 'Creatine', tags: ['Creatine'] },
    protein:   { label: 'Protein', tags: ['Protein'] },
    lattes:    { label: 'Lattes', tags: ['Lattes'] },
    greens:    { label: 'Greens', tags: ['Greens & Reds'] },
    omega:     { label: 'Omega-3', tags: ['Omega-3'] },
    mushrooms: { label: 'Mushrooms', tags: ['Mushrooms'] },
    accessories: { label: 'Accessories', tags: ['Accessories'] }
  };

  function quickDef() {
    var base = QUICK_DEFS[quickMode] || QUICK_DEFS.all;
    var txt = (T().quick || {})[quickMode] || {};
    return {
      collections: base.collections,
      tags: base.tags,
      onSale: base.onSale,
      label: txt.label || base.label,
      title: txt.title || base.title
    };
  }

  function cardMatchesQuick(card) {
    if (quickMode === 'all') return true;
    var def = quickDef();
    if (def.onSale && !card.hasAttribute('data-ld-sale')) return false;
    // not the badge: only one renders per card (sale > new > best)
    if (def.collections && cardHas(card, 'data-ld-collections', def.collections)) return true;
    if (def.tags && cardHas(card, 'data-ld-tags', def.tags)) return true;
    return !def.collections && !def.tags;
  }

  function cardHas(card, attr, wanted) {
    var have = (card.getAttribute(attr) || '').toLowerCase().split('||');
    for (var i = 0; i < wanted.length; i++) {
      if (have.indexOf(wanted[i].toLowerCase()) !== -1) return true;
    }
    return false;
  }

  var toastTimer = null;
  function toast(msg) {
    var t = document.querySelector('.ld-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ld-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 1800);
  }

  function productsWord(n) { return n === 1 ? (T().product || 'product') : (T().products || 'products'); }
  function plural(n) { return n + ' ' + productsWord(n); }

  // Shopify sorts by product, so variant-split cards inherit the product's min price
  function sortFlatByPrice() {
    var sort = (window.location.search.match(/[?&]sort_by=([^&]*)/) || [])[1];
    if (sort !== 'price-ascending' && sort !== 'price-descending') return;
    var dir = sort === 'price-ascending' ? 1 : -1;
    var lists = document.querySelectorAll('.product-list--collection:not([data-ld-grouped])');
    for (var i = 0; i < lists.length; i++) {
      var cards = Array.prototype.slice.call(lists[i].querySelectorAll('.landish-shopall-card'));
      if (cards.length < 2) continue;
      cards.sort(function (a, b) {
        return ((+a.getAttribute('data-ld-price') || 0) - (+b.getAttribute('data-ld-price') || 0)) * dir;
      });
      for (var c = 0; c < cards.length; c++) lists[i].appendChild(cards[c]);
    }
  }

  function applyFilters() {
    var boxes = document.querySelectorAll('.ld-filterdrawer [data-ld-facet]:checked');
    var types = [], tags = [];
    for (var i = 0; i < boxes.length; i++) {
      var facet = boxes[i].getAttribute('data-ld-facet');
      if (facet === 'type') types.push(boxes[i].value);
      else tags.push(boxes[i].value);
    }
    var pMinEl = document.querySelector('[data-ld-price-min]');
    var pMaxEl = document.querySelector('[data-ld-price-max]');
    var pMin = pMinEl && pMinEl.value !== '' && !isNaN(+pMinEl.value) ? Math.round(+pMinEl.value * 100) : null;
    var pMax = pMaxEl && pMaxEl.value !== '' && !isNaN(+pMaxEl.value) ? Math.round(+pMaxEl.value * 100) : null;
    var facetsActive = types.length > 0 || tags.length > 0 || pMin !== null || pMax !== null;
    var filtering = facetsActive || quickMode !== 'all';

    var cards = document.querySelectorAll('.landish-shopall-card');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var ok = cardMatchesQuick(card);
      if (ok && types.length) ok = types.indexOf(card.getAttribute('data-ld-type')) !== -1;
      if (ok && tags.length) {
        var cardTags = (card.getAttribute('data-ld-tags') || '').split('||');
        ok = false;
        for (var t = 0; t < tags.length; t++) {
          if (cardTags.indexOf(tags[t]) !== -1) { ok = true; break; }
        }
      }
      if (ok && (pMin !== null || pMax !== null)) {
        var price = +card.getAttribute('data-ld-price') || 0;
        if (pMin !== null && price < pMin) ok = false;
        if (ok && pMax !== null && price > pMax) ok = false;
      }
      card.classList.toggle('ld-filtered-out', !ok);
    }

    var heads = document.querySelectorAll('[data-ld-grouped] .ld-grid-section');
    var count = 0, total = 0;
    for (var h = 0; h < heads.length; h++) {
      var isBest = heads[h].hasAttribute('data-ld-bestsellers');
      // lead duplicates type-section cards
      var hideLead = isBest && filtering;
      var visible = 0, cardsInSection = 0;
      var el = heads[h].nextElementSibling;
      while (el && !el.classList.contains('ld-grid-section')) {
        if (el.classList.contains('landish-shopall-card')) {
          cardsInSection++;
          if (hideLead) el.classList.add('ld-filtered-out');
          if (!el.classList.contains('ld-filtered-out')) visible++;
        }
        el = el.nextElementSibling;
      }
      heads[h].classList.toggle('ld-filtered-out', visible === 0 || filtering);
      if (isBest) {
        var copy = quickDef();
        var title = heads[h].querySelector('h2');
        if (title) title.textContent = copy.title || (copy.label + ' picks');
      } else {
        count += visible;
        total += cardsInSection;
      }
    }

    if (heads.length === 0) {
      count = 0;
      var flatCards = document.querySelectorAll('.landish-shopall-card');
      total = flatCards.length;
      for (var fc = 0; fc < flatCards.length; fc++) {
        if (!flatCards[fc].classList.contains('ld-filtered-out')) count++;
      }
    }

    var toolbarCount = document.querySelector('.ld-toolbar__count');
    if (toolbarCount) toolbarCount.innerHTML = '<strong>' + count + '</strong> ' + productsWord(count);
    var apply = document.querySelector('.ld-filterdrawer__apply');
    if (apply) apply.textContent = (T().show || 'Show {count}').replace('{count}', plural(count));
    updateSeeAll(filtering, count, total);
  }

  function setQuick(mode) {
    quickMode = QUICK_DEFS[mode] ? mode : 'all';
    var chips = document.querySelectorAll('[data-ld-quick]');
    for (var q = 0; q < chips.length; q++) chips[q].classList.toggle('is-active', chips[q].getAttribute('data-ld-quick') === quickMode);
  }

  function clearFacets() {
    var checks = document.querySelectorAll('.ld-filterdrawer [data-ld-facet]:checked');
    for (var x = 0; x < checks.length; x++) checks[x].checked = false;
    var priceInputs = document.querySelectorAll('[data-ld-price-min], [data-ld-price-max]');
    for (var pi = 0; pi < priceInputs.length; pi++) priceInputs[pi].value = '';
  }

  function scrollToResults() {
    var bar = document.querySelector('.ld-stickybar');
    if (!bar) return;
    var off = parseInt(getComputedStyle(root).getPropertyValue('--ld-sticky-top'), 10) || 0;
    // a stuck bar reports where it's pinned; static gives its place in the flow
    bar.style.position = 'static';
    var target = Math.max(0, bar.getBoundingClientRect().top + window.pageYOffset - off);
    bar.style.position = '';
    if (window.pageYOffset > target) window.scrollTo({ top: target, behavior: 'smooth' });
  }

  function updateSeeAll(filtering, count, total) {
    var box = document.querySelector('.ld-seeall');
    if (!filtering) { if (box) box.hidden = true; return; }
    var copy = T().seeAll || {};
    if (!box) {
      var grids = document.querySelectorAll('.product-list--collection');
      var grid = grids[grids.length - 1];
      if (!grid) return;
      box = document.createElement('div');
      box.className = 'ld-seeall';
      box.innerHTML = '<p class="ld-seeall__count"></p><p class="ld-seeall__heading"></p><button type="button" class="ld-seeall__btn" data-ld-see-all></button>';
      box.querySelector('.ld-seeall__heading').textContent = copy.heading || 'Not finding what you’re looking for?';
      box.querySelector('.ld-seeall__btn').textContent = copy.button || 'See all products';
      grid.parentNode.insertBefore(box, grid.nextSibling);
    }
    var parts = (copy.showing || 'Showing {count} {products}').replace('{products}', productsWord(total)).split('{count}');
    var strong = document.createElement('strong');
    strong.textContent = (copy.count || '{shown} of {total}').replace('{shown}', count).replace('{total}', total);
    var line = box.querySelector('.ld-seeall__count');
    line.textContent = parts[0];
    line.appendChild(strong);
    line.appendChild(document.createTextNode(parts[1] || ''));
    box.hidden = false;
  }

  function closeAll() {
    root.classList.remove('ld-filter-open', 'ld-sort-open');
    closeScrim();
    closeSheet();
    setExpanded('[data-ld-open-filter], [data-ld-open-sort]', false);
    if (lastOpener && lastOpener.isConnected && lastOpener.focus) lastOpener.focus();
    lastOpener = null;
  }

  function switchTab(which, scope) {
    var tabs = scope.querySelectorAll('[data-ld-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-ld-tab') === which;
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    var panes = scope.querySelectorAll('[data-ld-pane]');
    for (var j = 0; j < panes.length; j++) panes[j].hidden = panes[j].getAttribute('data-ld-pane') !== which;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var tabBtn = t.closest('[data-ld-tab]');
    if (tabBtn) { switchTab(tabBtn.getAttribute('data-ld-tab'), tabBtn.closest('.ld-shopby') || document); return; }

    if (t.closest('[data-ld-open-filter]')) { e.preventDefault(); openFilter(); return; }
    if (t.closest('[data-ld-open-sort]')) { e.preventDefault(); openSort(); return; }

    var qf = t.closest('[data-ld-quick]');
    if (qf) {
      e.preventDefault();
      setQuick(qf.getAttribute('data-ld-quick'));
      applyFilters();
      scrollToResults();
      if (quickMode !== 'all') toast((T().toast || '{label} products shown').replace('{label}', quickDef().label));
      return;
    }

    var choose = t.closest('[data-ld-choose]');
    if (choose) {
      e.preventDefault();
      openChoose(choose.getAttribute('data-ld-choose'));
      return;
    }

    var blendBtn = t.closest('[data-ld-blend]');
    if (blendBtn) { e.preventDefault(); switchBlend(blendBtn); return; }

    var sizeBtn = t.closest('[data-ld-size]');
    if (sizeBtn) {
      var ssheet = sizeBtn.closest('.ld-choose-sheet');
      if (ssheet) {
        var sizes = ssheet.querySelectorAll('[data-ld-size]');
        for (var k = 0; k < sizes.length; k++) sizes[k].classList.remove('is-active');
        sizeBtn.classList.add('is-active');
        ssheet.dataset.onetime = sizeBtn.dataset.onetime;
        ssheet.dataset.sub = sizeBtn.dataset.sub;
        ssheet.dataset.servings = sizeBtn.dataset.serv;
        var vin = ssheet.querySelector('[data-ld-variant-input]'); if (vin) vin.value = sizeBtn.dataset.variant;
        var oneD = ssheet.querySelector('[data-ld-one-display]');
        if (oneD) {
          var oneP = +sizeBtn.dataset.onetime, oneC = +sizeBtn.dataset.compare || 0;
          if (oneC > oneP) { oneD.classList.add('ld-cs__mode-price--sale'); oneD.innerHTML = '<span class="ld-cs__price-now">' + money(oneP) + '</span><span class="ld-cs__price-was">' + money(oneC) + '</span>'; }
          else { oneD.classList.remove('ld-cs__mode-price--sale'); oneD.textContent = money(oneP); }
        }
        var subD = ssheet.querySelector('[data-ld-sub-display]');
        if (subD && +sizeBtn.dataset.sub > 0) {
          var subP = +sizeBtn.dataset.sub, subC = +sizeBtn.dataset.compare || 0;
          if (subC > 0) { subD.classList.add('ld-cs__mode-price--sale'); subD.innerHTML = '<span class="ld-cs__price-now">' + money(subP) + '</span><span class="ld-cs__price-was">' + money(subC) + '</span>'; }
          else { subD.classList.remove('ld-cs__mode-price--sale'); subD.textContent = money(subP); }
        }
        var img = ssheet.querySelector('.ld-cs__media img');
        if (img && sizeBtn.dataset.img) img.src = sizeBtn.dataset.img;
        var fine = ssheet.querySelector('[data-ld-fine]');
        if (fine) fine.classList.toggle('is-final-sale', String(sizeBtn.dataset.finalSale).toLowerCase() === 'true');
        recompute(ssheet);
      }
      return;
    }

    var qtyBtn = t.closest('[data-ld-qty]');
    if (qtyBtn) {
      var qsheet = qtyBtn.closest('.ld-choose-sheet');
      if (qsheet) {
        var v = qsheet.querySelector('[data-ld-qty-val]');
        var n = Math.max(1, Math.min(99, (+v.textContent || 1) + (+qtyBtn.getAttribute('data-ld-qty'))));
        v.textContent = n;
        recompute(qsheet);
      }
      return;
    }

    if (t.closest('[data-ld-filter-clear]')) {
      e.preventDefault();
      clearFacets();
      applyFilters();
      return;
    }

    if (t.closest('[data-ld-see-all]')) {
      e.preventDefault();
      setQuick('all');
      clearFacets();
      applyFilters();
      scrollToResults();
      return;
    }

    if (t.closest('[data-ld-close]')) { e.preventDefault(); closeAll(); return; }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var sheet = e.target.closest('.ld-choose-sheet');
    if (sheet) { recompute(sheet); return; }
    if (e.target.closest('[data-ld-facet], [data-ld-price-min], [data-ld-price-max]')) applyFilters();
  });
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-ld-price-min], [data-ld-price-max]')) applyFilters();
  });

  // company_id is read from the klaviyo.js tag already on the page, so each store posts to its own account
  function klaviyoCompany() {
    var sc = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
    var m = sc && sc.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : '';
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-ld-bis]')) return;
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-ld-bis-msg]');
    var email = (input.value || '').trim();
    function say(text, ok) { msg.textContent = text || ''; msg.hidden = !text; msg.classList.toggle('is-error', !ok); }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(form.dataset.msgInvalid, false); input.focus(); return; }
    var company = klaviyoCompany();
    if (!company) { say(form.dataset.msgError, false); return; }
    btn.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + form.dataset.variant } } }
      } })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      input.hidden = true;
      btn.hidden = true;
      say(form.dataset.msgSuccess, true);
    }).catch(function () {
      btn.disabled = false;
      say(form.dataset.msgError, false);
    });
  }, true);

  /* capture-phase + stopPropagation beats Rebuy's own /cart/add submit listener */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-ld-cs-form]')) return;
    e.preventDefault();
    e.stopPropagation();
    var sheet = form.closest('.ld-choose-sheet');
    recompute(sheet);
    var id = form.querySelector('[data-ld-variant-input]').value;
    var plan = form.querySelector('[data-ld-plan-input]').value;
    var qty = form.querySelector('[data-ld-qty-input]').value || 1;
    var item = { id: Number(id), quantity: Number(qty) };
    if (plan) item.selling_plan = Number(plan);
    var btn = form.querySelector('[data-ld-cs-add]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        closeAll();
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart_count').forEach(function (el) { el.textContent = cart.item_count; });
          })
          .catch(function () {});
      })
      .catch(function () {})
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // re-asserted on rebuy events: a one-shot flag races Rebuy's async open
  function syncSkipOpen() {
    if (window.Rebuy && window.Rebuy.SmartCart) window.Rebuy.SmartCart.skip_open = root.classList.contains('ld-collection');
  }
  ['rebuy:cart.ready', 'rebuy:cart.change'].forEach(function (ev) { document.addEventListener(ev, syncSkipOpen); });

  markCollection();
  markShopAll();
  updateStickyOffset();
  sortFlatByPrice();
  syncSkipOpen();
  requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('ld-ready'); }); });
  document.addEventListener('DOMContentLoaded', function () { markCollection(); markShopAll(); updateStickyOffset(); sortFlatByPrice(); syncSkipOpen(); });
  if (window.InstantClick) { window.InstantClick.on('change', function () { closeAll(); markCollection(); markShopAll(); updateStickyOffset(); sortFlatByPrice(); syncSkipOpen(); }); }
})();
